module.exports = __webpack_public_path__ + "static/img/backgroundImg.6b3b6639.png";